module.exports = __webpack_public_path__ + "static/media/4Hubris1Player.32f77b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forskar-fredag/4Hubris1Player.jpg
// module id = 197
// module chunks = 0